module.exports = __webpack_public_path__ + "img/underline-icon-white.66f44e23.svg";